"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_CLIENT_STEP_3_GROUPS = exports.CREATE_CLIENT_STEP_2_GROUPS = exports.CREATE_CLIENT_STEP_1_GROUPS = void 0;
const ECreateClientGroups_1 = require("./ECreateClientGroups");
exports.CREATE_CLIENT_STEP_1_GROUPS = [
    ECreateClientGroups_1.ECreateClientGroups.civility,
    ECreateClientGroups_1.ECreateClientGroups.lastName,
    ECreateClientGroups_1.ECreateClientGroups.firstName,
    ECreateClientGroups_1.ECreateClientGroups.maidenName,
    ECreateClientGroups_1.ECreateClientGroups.email,
    ECreateClientGroups_1.ECreateClientGroups.mobilePhone,
    ECreateClientGroups_1.ECreateClientGroups.address,
    ECreateClientGroups_1.ECreateClientGroups.maritalStatus,
    ECreateClientGroups_1.ECreateClientGroups.matrimonialRegime,
];
exports.CREATE_CLIENT_STEP_2_GROUPS = [
    ECreateClientGroups_1.ECreateClientGroups.nationality,
    ECreateClientGroups_1.ECreateClientGroups.birthDate,
    ECreateClientGroups_1.ECreateClientGroups.birthPlace,
    ECreateClientGroups_1.ECreateClientGroups.birthDepartment,
    ECreateClientGroups_1.ECreateClientGroups.birthCountry,
    ECreateClientGroups_1.ECreateClientGroups.categorieSocialProfessionnel,
    ECreateClientGroups_1.ECreateClientGroups.profession,
    ECreateClientGroups_1.ECreateClientGroups.lineOfBusiness,
];
exports.CREATE_CLIENT_STEP_3_GROUPS = [
    ECreateClientGroups_1.ECreateClientGroups.fiscalRegimes,
    ECreateClientGroups_1.ECreateClientGroups.nif,
    ECreateClientGroups_1.ECreateClientGroups.taxResidenceCountry,
    ECreateClientGroups_1.ECreateClientGroups.legalCapacity,
    ECreateClientGroups_1.ECreateClientGroups.politicallyExposed,
    ECreateClientGroups_1.ECreateClientGroups.personUS,
    ECreateClientGroups_1.ECreateClientGroups.agreementElectronicDocument,
    ECreateClientGroups_1.ECreateClientGroups.nonProfessionalClassificationAcknowledgment,
];
